import useFieldMapper from './useFieldMapper.tsx';
import { adaptEnGbRegistrationUserData } from '../api/register/adapters/en_gb_adapter.ts';
import { adaptMgaGraRegistrationUserData } from '../api/register/adapters/mga_gra_adapter.ts';
import { resolveMediaUrl, TCmsButton, TCmsFlow, TCmsStep } from '../cms';
import { TButtonField, TFlow, TStep } from '../types/types.ts';
import { MARKETS } from '../utils/markets.ts';

const getAdapter = (market: string) => {
  switch (market) {
  case MARKETS.SV:
    // TODO: Creat SV adapter and return it.
    return;
  case MARKETS.ENGB:
    return adaptEnGbRegistrationUserData;
  default:
    return adaptMgaGraRegistrationUserData;
  }

};

const mapButton = (buttons?: TCmsButton[] | null): TButtonField => ({
  label:      buttons?.[0]?.label ?? undefined,
  gtmPayload: buttons?.[0]?.gtmPayload ?? undefined,
  fieldType:  buttons?.[0]?.fieldType,
  redirectTo: buttons?.[0]?.redirectTo ?? undefined,
  name:       buttons?.[0]?.name ?? undefined,
});

const useTransformData = () => {
  const { mapField } = useFieldMapper();

  const transformData = (flow: TCmsFlow): TFlow => {
    const steps: Record<number, TStep> = {};

    flow.steps.forEach((step: TCmsStep, idx) => {
      const stepOrder = idx + 1;

      steps[stepOrder] = {
        stepName:         step.key,
        name:             step.name ?? '',
        fields:           step.fields.map(field => mapField(field)),
        isStep:           step.isStep ?? undefined,
        backgroundColor:  step.backgroundColor ?? undefined,
        overflowingColor: step.overflowingColor ?? undefined,
        headerTextColor:  step.headerTextColor ?? undefined,
        backgroundImage:  resolveMediaUrl(step.backgroundImage),
        headerIcon:       resolveMediaUrl(step.headerIcon),
        title:            step.title ?? undefined,
        description:      step.description ?? undefined,
        details:          step.details ?? undefined,
        navigationText:   step.navigationText ?? undefined,
        currentStepText:  step.currentStepText ?? 'Step {currentStep} of {totalSteps}',
        primaryButton:    mapButton(step.primaryButton),
        secondaryButton:  mapButton(step.secondaryButton),
      };
    });

    return {
      name:    flow.name || 'en',
      steps,
      adapter: getAdapter(flow.name),
    };
  };

  return {
    transformData,
  };
};

export default useTransformData;
